/* MAA Kit Builder — UI shell.
   Knows nothing about bikes or prices. Reads the platform registry the section
   renders (id, label, years, url) and asks MAAKB to resolve everything else.

   Depends on maa-kb-engine.js being loaded first.
*/
(function () {
  "use strict";

  function boot(ROOT) {
    if (!ROOT || ROOT.dataset.booted) return;
    ROOT.dataset.booted = "1";

    var reg = ROOT.querySelector('[data-maa-platforms]');
    if (!reg) return;
    var PLATFORMS;
    try { PLATFORMS = JSON.parse(reg.textContent); } catch (e) { return; }

    var $ = function (sel) { return ROOT.querySelector(sel); };
    var STEPS = $('[data-el="steps"]'), OPTS = $('[data-el="opts"]'), OUT = $('[data-el="out"]');

    /* The sticky bar is moved to <body>. Horizon's section wrappers carry
       transform/contain, which would otherwise trap position:fixed. */
    var BAR = ROOT.querySelector(".bar"), SHELL = null;
    if (BAR) {
      var key = ROOT.id || "maa-kb";
      Array.prototype.forEach.call(
        document.querySelectorAll('.maa-kb-barshell[data-for="' + key + '"]'),
        function (n) { n.remove(); });
      SHELL = document.createElement("div");
      SHELL.className = "maa-kb maa-kb-barshell";
      SHELL.setAttribute("data-for", key);
      SHELL.appendChild(BAR);
      document.body.appendChild(SHELL);
    }
    function el(id) {
      return ROOT.querySelector('[data-el="' + id + '"]') ||
             (SHELL && SHELL.querySelector('[data-el="' + id + '"]'));
    }
    // Every matching hook, across the section and the reparented bar. Writing to
    // all of them means a duplicated hook can never leave one copy stale.
    function all(sel) {
      var out = Array.prototype.slice.call(ROOT.querySelectorAll(sel));
      if (SHELL) out = out.concat(Array.prototype.slice.call(SHELL.querySelectorAll(sel)));
      return out;
    }
    function setText(id, txt) {
      all('[data-el="' + id + '"]').forEach(function (n) { n.textContent = txt; });
    }
    function setDisabled(off) {
      all("[data-atc]").forEach(function (n) { n.disabled = off; });
    }

    /* The sheet also lives on <body> so it is never clipped by a section. */
    var SH = document.createElement("div");
    SH.className = "maa-kb maa-kb-sheet";
    SH.setAttribute("aria-hidden", "true");
    SH.innerHTML =
      '<div class="scrim" data-close></div>' +
      '<div class="sheet" role="dialog" aria-modal="true"><div class="grab"></div>' +
      '<h3 data-sh="t"></h3><p class="sub2" data-sh="s"></p><div data-sh="b"></div>' +
      '<button class="back" data-sh="f" data-close type="button">Close</button></div>';
    document.body.appendChild(SH);

    var P = null, S = null, LAST_BUILD = null;
    // Set when Shopify has just sent the rider back from a good enquiry post.
    var POSTED = false, POSTED_BIKE = "";
    /* The router. Model and exact year are the only two things we ask the rider
       about their bike; the architecture, fitment family and platform file are
       all derived from them. See claude/model-year-router.md. */
    var MAN = null, CARD = null, YEAR = null, ROW = null;
    // Which model group the rider has filtered to. null means all of them.
    var GRP = null;

    /* Arriving from a bike-specific collection.

       The banner on /collections/street-glide-audio-2014-2023 links here with
       ?from=batwing_14_23. That narrows WHICH CARDS ARE OFFERED. It must never
       narrow which years are offered, and it must never choose the bike.

       The distinction is the whole safety argument. A collection page is a
       guess about the rider — a 2019 Street Glide owner browsing the 2024+
       collection is a completely ordinary thing to do. Pre-SELECTING their bike
       from that guess would route them to the wrong platform silently. Showing
       them a shorter list of cards, with every year still on each card and a
       visible way back to the full list, cannot put anyone anywhere wrong: they
       still pick the badge, they still pick the year.

       Accepts several keys (?from=batwing_24,sharknose_24) because the 2024+
       Touring collections cover both fairings. Unknown keys are dropped rather
       than honoured, so a stale or mistyped link degrades to the full list
       instead of an empty one. */
    var FROM = null;
    function readFrom() {
      var m = /[?&]from=([^&#]*)/.exec(location.search);
      if (!m || !MAN || !MAN.fit) return null;
      var want = decodeURIComponent(m[1].replace(/\+/g, " "))
                   .split(",")
                   .map(function (k) { return k.trim(); })
                   .filter(function (k) { return k && MAN.fit[k]; });
      return want.length ? want : null;
    }
    function fitsFrom(c) {
      if (!FROM) return true;
      return c.rows.some(function (r) { return FROM.indexOf(r.fit) >= 0; });
    }
    /* The short form ("2024+ Batwing"), not the long one ("Batwing fairing,
       2024+"), because this reads inside a sentence about what is being shown.
       Falls back to the long label, so a fit key added without a `short` still
       renders something true rather than a raw key. */
    function fromLabel() {
      if (!FROM) return "";
      var ls = FROM.map(function (k) {
        var f = MAN.fit[k] || {};
        return f.short || f.label || k;
      });
      return ls.length === 1 ? ls[0] : ls.slice(0, -1).join(", ") + " and " + ls[ls.length - 1];
    }
    /* How many cards the referral leaves on the table. Used by the collapsed
       step row, so the hand-off is visible BEFORE the picker is opened —
       otherwise arriving from a collection looks identical to arriving cold and
       the referral has no user-facing value at all.

       Returns 0 when nothing is filtered, so callers can stay quiet. */
    function fromCount() {
      if (!FROM || !MAN) return 0;
      var n = MAN.cards.filter(fitsFrom).length;
      return (n && n < MAN.cards.length) ? n : 0;
    }
    // Which step the rider has opened by hand. Null means "the first one
    // still needing an answer", which is the behaviour on first load.
    var OPEN = null;
    /* Step numbers, named. They used to run 1, 2, 4 — a third step asked which
       bike range the rider was in, and it went when the router started deriving
       that from model and year. Nobody closed the numbers up, and the literal 4
       was also the "open the level step" signal in the click handler, so
       renumbering by hand silently broke the auto-advance. Once. */
    var STEP = { bike: 1, positions: 2, level: 3 };

    // The Liquid-rendered contact form. Nothing else may post an enquiry.
    function CBHOST() { return ROOT.querySelector("[data-cb-host]"); }
    function hideCbHost() {
      var h = CBHOST();
      if (h) h.hidden = true;
      if (OUT) OUT.hidden = false;
    }

    function money(n) {
      return (n < 0 ? "−" : "") + "$" +
        Math.abs(n).toLocaleString("en-AU", { maximumFractionDigits: 0 });
    }
    /* The footer control is navigation, not dismissal, wherever there is
       somewhere to navigate back to. The year sheet is only ever reached by
       picking a card, so the model list is always behind it — and a rider who
       opens the years and realises they chose the wrong bike wants that list,
       not the page they started on. Cancelling out of a two-step flow and
       landing back at the beginning is the whole complaint.

       The scrim and Escape still dismiss outright. Those are "get me out of
       here" gestures; the labelled button is a step backwards. */
    function fillSheet(t, s, html, back) {
      SH.querySelector('[data-sh="t"]').innerHTML = t;
      SH.querySelector('[data-sh="s"]').innerHTML = s;
      SH.querySelector('[data-sh="b"]').innerHTML = html;
      var f = SH.querySelector('[data-sh="f"]');
      f.textContent = back ? "Back" : "Close";
      f.setAttribute(back ? "data-back" : "data-close", "");
      f.removeAttribute(back ? "data-close" : "data-back");
    }
    // Opening an already-open sheet cross-fades its contents rather than
    // closing and reopening, so moving from range to model is one gesture.
    function openSheet(t, s, html, back) {
      if (SH.hasAttribute("open")) {
        SH.classList.add("swapping");
        setTimeout(function () {
          fillSheet(t, s, html, back);
          SH.classList.remove("swapping");
        }, 160);
        return;
      }
      fillSheet(t, s, html, back);
      SH.setAttribute("open", ""); SH.setAttribute("aria-hidden", "false");
    }
    function closeSheet() { SH.removeAttribute("open"); SH.setAttribute("aria-hidden", "true"); }

    function hasKit(c) {
      return c.rows.some(function (r) { return r.bom_status === "approved"; });
    }
    function rowFor(c, y) {
      for (var i = 0; i < c.rows.length; i++) {
        if (y >= c.rows[i].from && y <= c.rows[i].to) return c.rows[i];
      }
      return null;
    }
    /* Every known model year is offered, whatever its BOM status. Hiding the
       years we have not built kits for reintroduced exactly the doubt this
       navigation removes — an Ultra Limited owner tapping their model and seeing
       2014-2023 is left wondering whether they misremembered their own bike.
       Status changes where they land, never whether their bike appears. */
    function yearsOf(c) {
      var out = [];
      c.rows.forEach(function (r) { for (var y = r.to; y >= r.from; y--) out.push(y); });
      return out.sort(function (a, b) { return b - a; });
    }

    /* Cross-listing only applies once a group is chosen. Showing a card under two
       headings in the unfiltered view reads as a duplicate rather than as help. */
    function inGroup(c, f, filtered) {
      return c.family === f || (filtered && (c.also || []).indexOf(f) >= 0);
    }
    /* Three groups: Touring is the default, CVO and Trike are the two departures
       riders name unprompted. The chips filter rather than gate — nobody pays a
       tap they did not want, and a CVO owner gets there in one. */
    function modelSheet() {
      if (!MAN) return;
      var h = '<div class="chips"><button class="chip' + (GRP ? "" : " on") +
              '" data-grp="" type="button">All</button>';
      MAN.families.forEach(function (f) {
        h += '<button class="chip' + (GRP === f.id ? " on" : "") +
             '" data-grp="' + f.id + '" type="button">' + f.label + "</button>";
      });
      h += "</div>";

      /* Fail open. If the filter would leave nothing to pick — a fit key that no
         card claims yet, a collection mapped to the wrong platform — showing the
         full list is wrong-but-usable, and showing an empty sheet is a dead end.
         Checked across every family, not per family, because a fit that only
         appears under Trike is still a perfectly good filter. */
      var narrowed = !!FROM && MAN.cards.some(fitsFrom);

      if (narrowed) {
        /* "Showing <X> models", not "models that fit your bike" — at this point
           the rider has told us nothing. The referral narrowed a list; it did
           not identify a motorcycle, and the wording must not claim otherwise.
           The escape sits on the same line, not buried at the foot of the
           sheet: narrowed to save you time, still your choice. */
        h += '<div class="from-note">Showing <b>' + fromLabel() +
             '</b> models <button class="from-all" data-from-all="1" type="button">' +
             'Show all models</button></div>';
      }

      MAN.families.forEach(function (f) {
        if (GRP && GRP !== f.id) return;
        var cs = MAN.cards.filter(function (c) {
          return inGroup(c, f.id, !!GRP) && (!narrowed || fitsFrom(c));
        });
        if (!cs.length) return;
        // With one group showing, the heading just repeats the active chip.
        if (!GRP) h += '<div class="fam">' + f.label + "</div>";
        h += '<div class="mods">';
        cs.forEach(function (c) {
          h += '<button class="opt' + (hasKit(c) ? "" : " nokit") + '" data-card="' + c.id +
               '" type="button"><b>' + c.label + "</b>" +
               (hasKit(c) ? "" : "<small>Custom build</small>") + "</button>";
        });
        h += "</div>";
      });
      /* "We can still help" was a promise with no mechanism attached — the rider
         had to take it on faith. Name what actually happens instead: they tell
         us the bike, a person specs it. That is the same thing the Custom Build
         form on the other side of this button does. */
      h += '<button class="opt esc" data-esc="1" type="button"><b>Can&rsquo;t find your model?</b>' +
           "<small>Imports, older bikes and heavily modified Harleys &mdash; tell us what you ride " +
           "and we&rsquo;ll spec the system by hand</small></button>";
      openSheet("What Harley do you ride?", "Pick the badge on your bike. We work out the rest.", h);
    }

    /* Why a part is in this kit.

       The product page can already say what a thing is. The only question it
       cannot answer is why it turned up in YOUR build, and that is the one the
       resolver can. So this stays short on purpose: one sentence of reason, the
       line price, and a link out for anyone who wants the full page.

       Installation parts mostly explain themselves already — "6 AWG — correct
       for the FLX700.4", "Decodes the 2024+ A2B digital bus. Not optional on
       these bikes." Those are reasons, not specs, so they are used as written.
       Amplifier and speakers are the two that need the build's context, because
       "700W RMS · 175W × 4 @ 2Ω" says what it is and nothing about why. */
    function whyLine(l, pt, b) {
      if (l.g === "Amplifier") {
        return "The amplifier for " + levelName(b.level) +
               ". Speaker choice, wiring gauge and the set-up targets below are all matched to it.";
      }
      if (l.g === "Speakers") {
        /* "Your saddlebags speakers" is what the obvious phrasing produces, so
           the position is a noun here rather than an adjective. It reads right
           for all three: your fairing, your saddlebags, your Tour-Pak. */
        var names = (l.pos || []).map(function (k) {
          return (P.positionMeta && P.positionMeta[k] && P.positionMeta[k].short) || k;
        });
        var where = names.length ? "your " + names.join(" and ") : "this build";
        /* "The Speaker Upgrade speakers for your fairing" says speakers
           twice. A numbered level is an adjective here ("the Level 1
           speakers"); a named one is not, so it drops out of the sentence
           rather than being forced into it. */
        return (b.level && b.level.name ? "The speakers for " : "The " + levelName(b.level) + " speakers for ") +
               where + (pt.ohm ? ", wired at " + pt.ohm + "Ω for this combination." : ".");
      }
      return pt.s || "Part of the standard fitment for this bike.";
    }

    function whySheet(sku) {
      var b = LAST_BUILD, pt = P && P.parts[sku];
      if (!pt || !b) return;
      var l = b.lines.filter(function (x) { return x.sku === sku; })[0] || { g: "", pos: [] };
      var why = whyLine(l, pt, b);
      var h = '<p class="why">' + why + "</p>" +
        '<div class="why-m"><span>' + sku + "</span><span>" +
        (function () {
          // Through the engine, so this line agrees with the total above it.
          var u = MAAKB.priceOf(pt);
          return l.qty > 1 ? l.qty + " × " + money(u) + " = " + money(u * l.qty) : money(u);
        })() +
        "</span></div>";
      if (pt.h) {
        h += '<a class="why-lnk" href="/products/' + pt.h + '" target="_blank" rel="noopener">' +
             "Full product details &rarr;</a>";
      }
      /* Installation parts explain themselves — their spec line IS the reason,
         so showing it as both subtitle and body just says everything twice. */
      openSheet(l.label || pt.n, pt.s && pt.s !== why ? pt.s : "", h, false);
    }

    function yearSheet() {
      if (!CARD) return;
      var h = '<div class="yrs">';
      yearsOf(CARD).forEach(function (y) {
        h += '<button class="yr" data-year="' + y + '" type="button">' + y + "</button>";
      });
      openSheet("What year is your " + CARD.label + "?",
                "Every year this model was built.", h + "</div>", true);
    }

    function selectCard(id) {
      POSTED = false;
      CARD = MAN.cards.filter(function (c) { return c.id === id; })[0] || null;
      YEAR = null; ROW = null; P = null; S = null; OPEN = null;
      render();
      yearSheet();       // cross-fades in place
    }
    /* A year without an approved BOM is not an error and not an unknown bike —
       it is a bike we have not built a shelf kit for. It resolves, it is named
       back to the rider, and it routes to a custom build rather than to a guess. */
    function selectYear(y) {
      YEAR = y; ROW = rowFor(CARD, y);
      if (!ROW || ROW.bom_status !== "approved") {
        P = null; S = null; closeSheet(); render(); return;
      }
      var pid = MAN.elec[ROW.elec].platform;
      var meta = PLATFORMS.filter(function (x) { return x.id === pid; })[0];
      if (!meta) { P = null; S = null; closeSheet(); render(); return; }
      function apply() {
        P = MAAKB.platform(pid);
        S = MAAKB.newState(P);
        S.model = ROW.model;
        OPEN = null; closeSheet(); render();
      }
      if (MAAKB.platform(pid)) return apply();
      MAAKB.loadPlatform(pid, meta.url).then(apply).catch(function () {
        openSheet("Sorry", "We could not load the options for that bike.",
                  '<p class="gst">Please try again, or call 07 3350 1354.</p>');
      });
    }

    /* `prompt` borrows the selected-option look — orange border, tinted fill —
       for the one step that has not been answered yet. It is the first thing a
       rider has to do and it was reading as just another grey row. The class
       comes off the moment a bike is chosen, so the highlight never competes
       with the options below it. */
    function stepEl(n, lbl, val, done, go, locked, hint) {
      return '<div class="step ' + (done ? "done " : "prompt ") + (locked ? "locked" : "") + '">' +
        '<button class="step-hd" type="button" ' + (go ? 'data-go="' + go + '"' : "") + '>' +
        '<div class="num">' + n + '</div><div class="step-t"><b>' + lbl + '</b>' +
        '<span>' + val + '</span>' +
        (hint ? '<span class="step-hint">' + hint + '</span>' : "") +
        '</div><div class="chev">›</div></button></div>';
    }
    /* An answered step collapses, but stays reopenable — the header is a toggle.
       Without this a rider who picked a level could not go back and change it,
       or revisit their speaker locations, without reloading the page. */
    function grp(n, lbl, val, done, locked, body) {
      var isOpen = locked ? false : (OPEN === null ? !done : OPEN === n);
      return '<div class="step ' + (done ? "done " : "") + (locked ? "locked " : "") +
        (isOpen ? "open active" : "") + '">' +
        '<button class="step-hd" type="button"' +
        (locked ? "" : ' data-toggle="' + n + '"') +
        ' aria-expanded="' + (isOpen ? "true" : "false") + '"><div class="num">' + n + '</div>' +
        '<div class="step-t"><b>' + lbl + '</b><span>' + val + '</span></div>' +
        '<div class="chev">›</div></button>' +
        '<div class="step-bd"><div class="opts">' + body + '</div></div></div>';
    }
    function btn(k, v, sel, label, desc, delta) {
      return '<button class="opt' + (sel ? " sel" : "") + '" data-set="' + k + '" data-v="' + v +
        '" type="button" aria-pressed="' + (sel ? "true" : "false") +
        '"><span class="tick">✓</span><b>' + label +
        // "Same price" is not a figure and must not shout like one — .delta is
        // orange and bold because a price change is the thing to notice.
        (delta !== undefined
          ? ' <span class="delta' + (delta.indexOf("$") < 0 ? " delta-same" : "") + '">' +
            delta + "</span>"
          : "") + "</b>" +
        (desc ? "<small>" + desc + "</small>" : "") + "</button>";
    }

    /* What a level is CALLED, which is not always "Level " + its id.

       The ladder numbers mean something: they run cheapest to dearest along one
       axis — more amplifier, more speakers, more processing. A speaker-only
       build is not a rung on that ladder. It keeps the factory amplifier
       entirely, so calling it "Level 8" implies it sits above Level 7 when it
       is a different kind of purchase altogether, and the cheapest thing on the
       page.

       So a level may name itself. `id` stays the identity — it is what `_build`
       records on the order and what state and rules key on — and `name` is only
       ever the label. Nothing here special-cases an id: a second speaker-only
       level on another platform names itself the same way. */
    function levelById(id) {
      var ls = (P && P.levels) || [];
      for (var i = 0; i < ls.length; i++) if (ls[i].id === id) return ls[i];
      return null;
    }
    function levelName(L) {
      if (L && L.name) return L.name;
      return "Level " + (L && L.id != null ? L.id : "");
    }

    function levels() {
      var body = "";
      /* Only the levels this bike can take. A level that depends on a position
         the model does not have is not a locked upsell — it is absent, exactly
         as an unavailable speaker position is absent. Groups whose every level
         is filtered out drop their heading too, or the ladder grows labels with
         nothing under them. */
      var avail = MAAKB.levelsFor(P, S);
      var okId = {};
      avail.forEach(function (L) { okId[L.id] = true; });

      (P.groups || [{ ids: avail.map(function (l) { return l.id; }) }]).forEach(function (g) {
        var ids = g.ids.filter(function (id) { return okId[id]; });
        if (!ids.length) return;
        if (g.label) body += '<div class="grp-lbl">' + g.label + "</div>";
        ids.forEach(function (id) {
          var L = P.levels.filter(function (x) { return x.id === id; })[0];
          var probe = {}; for (var k in S) probe[k] = S[k]; probe.level = id;
          var t = MAAKB.levelTotal(P, probe, id);
          body += '<button class="opt lvl' + (S.level === id ? " sel" : "") +
            '" data-set="level" data-v="' + id + '" type="button"' +
            ' aria-pressed="' + (S.level === id ? "true" : "false") + '">' +
            '<span class="tick">✓</span>' +
            '<span class="lvl-top"><b>' + levelName(L) +
            (MAAKB.hasDsp(L) ? ' <span class="badge b-dsp">DSP</span>' : "") + "</b>" +
            '<span class="lvl-price">' + (t == null ? "" : money(t)) + "</span></span>" +
            /* The amplifier line names every amplifier, and the processor when
               it is a separate box. "FLX1400.4 + FLX700.4 + DSP412PRO" is the
               honest description of a two-amp active system; showing only the
               first would understate what is in the price. */
            '<span class="amp">' + MAAKB.ampsOf(L).join(" + ") +
            (L.dspPart ? " + " + L.dspPart : "") +
            (L.dsp && !L.dspPart && P.arch === "a2b" ? " + ZEN-H PRO" : "") + "</span>" +
            '<span class="spk">' + (L.blurb || L.warn || "") + "</span>" +
            /* A level is described by what it gains. Level 4 used to open "No
               integrated DSP — choose Level 5", which named a hole rather than a
               system and made the cheaper-but-more-powerful option read as
               broken. The pointer to Level 5 is still there, demoted to a
               secondary line. */
            (L.note ? '<span class="lvl-note">' + L.note + "</span>" : "") +
            "</button>";
        });
      });
      return grp(STEP.level, "System level",
                 S.level ? levelName(levelById(S.level)) : "Choose your level",
                 !!S.level, !S.positions, body);
    }

    // Price delta a choice would make, against the current state.
    function delta(g, cid) {
      var probe = {}; for (var k in S) probe[k] = S[k]; probe[g.state] = cid;
      var a = MAAKB.resolve(P, probe), b = MAAKB.resolve(P, S);
      return (a && b) ? a.total - b.total : 0;
    }
    /* The delta is measured against the current state, so the option a rider has
       already chosen is always zero — and it was rendering as a bare em dash
       hanging off the label ("Factory solid lids —"), which reads as a price
       that failed to load.

       Selected: say nothing. There is no change to make.
       Not selected, same price: say so — "free to switch" is worth knowing, and
       it is the one case where zero carries information. */
    /* "save $3,095", not "−$3,095".

       Every delta here is measured against the configuration the rider
       currently has, so a bare signed number asks them to work out both the
       direction and what it is relative to. Naming the action removes the
       arithmetic: a minus sign is information, "save" is a reason. */
    function money2(d, sel) {
      if (sel) return undefined;
      if (d === 0) return "Same price";
      var amt = "$" + Math.abs(d).toLocaleString("en-AU");
      return d > 0 ? "+" + amt : "save " + amt;
    }
    function choices(g) {
      return g.choices.map(function (c) {
        var sel = S[g.state] === c.id;
        return btn(g.state, c.id, sel, c.label, c.desc || "", money2(delta(g, c.id), sel));
      }).join("");
    }
    /* A sub-question rendered directly beneath the option it belongs to, rather
       than as another block further down the page. Groups declare their parent
       with `under`; without that the renderer has no way to know that "OEM
       integration" belongs to the WHD14+ and not to the page. */
    /* One badge, everywhere. `factoryAmp` carries tag "Required" and is a
       TOP-LEVEL group, so before this it rendered no badge at all while the
       nested groups did — the same word meaning the same thing, shown in two
       different ways depending on where it happened to sit. */
    function tagBadge(g) {
      if (!g.tag) return "";
      return ' <span class="opt-tag' + (g.tag === "Required" ? " req" : "") + '">' +
             g.tag + "</span>";
    }
    function subGroup(g) {
      var unmet = g.required && !S[g.state];
      return '<div class="subopt' + (unmet ? " needed" : "") + '">' +
        "<h3>" + g.label + tagBadge(g) + "</h3>" +
        // Why a rider would want this, above the choices — benefit first, rather
        // than a list of which models do and don't need it.
        (g.note ? '<p class="sub-note">' + g.note + "</p>" : "") +
        '<div class="opts two">' + choices(g) + "</div>" +
        (unmet && g.reqMsg ? '<p class="req-msg">' + g.reqMsg + "</p>" : "") +
        "</div>";
    }

    function options() {
      if (!P || !S.level) return "";
      var gs = MAAKB.visibleGroups(P, S), h = "";
      if (!gs.length) return "";

      // Split visible groups into top-level blocks and the children that hang
      // off one of their choices.
      var kids = {};
      var tops = gs.filter(function (g) {
        if (g.under && g.under.group) {
          (kids[g.under.group] = kids[g.under.group] || []).push(g);
          return false;
        }
        return true;
      });

      h += "<h2>Complete your system</h2>";
      tops.forEach(function (g) {
        h += '<div class="grp"><div class="grp-lbl">' + g.label + tagBadge(g) + "</div>" +
             (g.note ? '<p class="sub-note grp-note">' + g.note + "</p>" : "") +
             '<div class="opts">';
        g.choices.forEach(function (c) {
          var sel = S[g.state] === c.id;
          h += btn(g.state, c.id, sel, c.label, c.desc || "", money2(delta(g, c.id), sel));
          if (!sel) return;
          var sub = (kids[g.id] || []).filter(function (k) {
            return !k.under.choice || k.under.choice === c.id;
          }).map(subGroup).join("");
          if (sub) h += '<div class="subs">' + sub + "</div>";
        });
        h += "</div></div>";
      });
      return h;
    }

    /* Speaker locations are generated from the model, not from a shared list.
       The fairing is always in — there is no system without it — so the rider is
       really choosing which of the remaining positions to add. A model with no
       saddlebags simply never produces a saddlebag option. */
    function posKey(list) { return list ? list.join("|") : null; }

    function posOptions() {
      if (!P || !S.model) return [];
      var all = MAAKB.positionsFor(P, S);
      var front = MAAKB.FRONT;
      var rear = all.filter(function (k) { return k !== front; });
      var meta = P.positionMeta || {};
      function nm(k) { return (meta[k] && meta[k].short) || k; }
      // {size} is filled from the part this bike will actually receive, so a CVO
      // reads "5×7″ in the bag lids" and a standard bike reads "6×9″".
      function dsc(k) {
        var t = (meta[k] || {}).desc || "";
        return t.replace("{size}", MAAKB.sizeFor(P, S, k) || "");
      }

      var out = [];
      // Every subset of the rear positions, smallest first, front always present.
      for (var mask = 0; mask < (1 << rear.length); mask++) {
        var picked = rear.filter(function (_, i) { return mask & (1 << i); });
        var list = [front].concat(picked);
        out.push({
          key: posKey(list),
          list: list,
          n: picked.length,
          label: picked.length
            ? "Fairing + " + picked.map(nm).join(" + ")
            : "Fairing only",
          desc: picked.length
            ? picked.map(dsc).join(" ")
            : dsc(front)
        });
      }
      out.sort(function (a, b) { return a.n - b.n; });
      return out;
    }

    /* Name the bike back to the rider the way THEY named it, not the way the
       resolver files it. One BOM key serves several cards — `RGL` is labelled
       "Road Glide Limited / Ultra" and `ULT` is "Ultra Limited / Ultra Classic"
       — so printing the model label told a 2018 Road Glide Ultra owner they
       were buying a kit for something else. Cards-not-keys has to hold all the
       way to the last line of the summary, not just in the picker. */
    function bikeName(b) {
      if (CARD && YEAR) return YEAR + " " + CARD.label;
      if (CARD) return CARD.label;
      return b.model.label;
    }

    function render() {
      var h = "";
      /* Model and year collapse into one fact once both are answered. Two open
         accordion sections for "your bike" wasted the space the questions that
         follow need, and riders think of it as one thing anyway. */
      var bike = (CARD && YEAR) ? (YEAR + " " + CARD.label)
               : CARD ? CARD.label : "Choose your Harley";
      /* Deliberately "N matching models", never "N models that match your bike".
         The referral tells us which page they came from, not what they ride, and
         the copy has to stop exactly where the evidence does. Disappears the
         moment a card is chosen, because from then on the real answer is shown. */
      var bikeHint = null;
      if (!CARD) {
        var nFrom = fromCount();
        if (nFrom) bikeHint = nFrom + " matching model" + (nFrom === 1 ? "" : "s");
      }
      h += stepEl(STEP.bike, "Your bike", bike, !!(CARD && YEAR), "model", false, bikeHint);
      if (P && S) {
        var opts = posOptions();
        var cfgs = opts.map(function (o) {
          return btn("positions", o.key, posKey(S.positions) === o.key, o.label, o.desc);
        }).join("");
        var cur = opts.filter(function (o) { return o.key === posKey(S.positions); })[0];
        /* Label names the question, value carries the answer — same shape as
           step 1, and the number is already in the circle to the left. The
           steps used to read 1, 2, 4: there was a third asking which bike range
           the rider was in, and it went when the router started deriving that
           from model and year. The numbers were never closed up. */
        h += grp(STEP.positions, "Speaker locations", cur ? cur.label : "Choose your locations",
                 !!S.positions, !S.model, cfgs);
        if (S.positions) h += levels();
      }
      // Writing innerHTML tears down and rebuilds every step, so only do it when
      // the markup genuinely differs. Most state changes touch one step's label.
      if (STEPS.innerHTML !== h) STEPS.innerHTML = h;
      var o = options();
      if (OPTS.innerHTML !== o) OPTS.innerHTML = o;
      renderOut();
    }

    /* Custom build. Eight of the fifteen model cards route here today, so this is
       a real path through the product, not a dead end. The bike is already
       identified by the time anyone arrives — the form carries that forward so
       nobody has to re-explain what we already worked out. */
    function customBuild(row) {
      var who = (CARD && YEAR) ? (YEAR + " " + CARD.label) : "your Harley";
      var head = row === null && !CARD
        ? "Tell us about your bike"
        : "We haven't released a standard kit for this one yet";
      var lede = row === null && !CARD
        ? "Imports, older bikes and heavily modified Harleys — we'd rather spec yours properly than guess from the closest match."
        : "We know the bike. We just haven't signed off a shelf kit for it, and we won't guess at one.";
      /* Where the rider clicked through a model and a year we already know the
         bike, so asking again is asking someone to repeat themselves. Where they
         arrived via the escape hatch we know nothing — and the heading says
         "Tell us about your bike", so there had better be somewhere to tell us.
         The field appears on exactly that path and nowhere else. */
      var known = !!(CARD && YEAR);
      var bikeField = known
        ? '<div class="cb-bike">' + who + "</div>"
        : "<label>What do you ride?" +
          '<input name="contact[bike]" data-cb="bike" type="text" placeholder="Year, model and any big changes — e.g. 2012 Street Glide, imported">' +
          "</label>";
      /* Written into the Liquid-rendered contact form rather than into the
         output panel. The fields carry real contact[...] names, so Shopify
         lists them in the email in their own right and the send button is the
         form's own submit button — no programmatic submit, no captcha to
         outwit. */
      var host = CBHOST(), slot = host && host.querySelector("[data-cb-fields]");
      if (!slot) {
        OUT.innerHTML = '<div class="cb"><b>Something is missing on this page.</b>' +
          "<p>The enquiry form did not load. Please call 07 3350 1354 or email " +
          "sales@motorcycleaudio.com.au and we'll pick it up from there.</p></div>";
        return;
      }
      slot.innerHTML =
        '<div class="cb"><b>' + head + "</b><p>" + lede + "</p>" +
        bikeField +
        '<label>Your name<input name="contact[name]" data-cb="name" type="text" autocomplete="name"></label>' +
        '<label>Email<input name="contact[email]" data-cb="email" type="email" autocomplete="email"></label>' +
        '<label>Phone <span class="cb-opt">(optional)</span>' +
        '<input name="contact[phone]" data-cb="phone" type="tel" autocomplete="tel"></label>' +
        "<label>What's already fitted? Anything we should know?" +
        '<textarea name="contact[notes]" data-cb="notes" rows="3" placeholder="Factory audio, aftermarket head unit, speaker lids, previous work…"></textarea></label>' +
        /* Honeypot. Real riders never see it; bots fill everything they find.
           No contact[...] name, so it never reaches the email either way.
           Hidden from assistive tech too, so a screen reader is not asked to
           complete a field that exists only to be left empty. */
        '<div class="cb-hp" aria-hidden="true"><label>Leave this empty' +
        '<input data-cb="hp" type="text" tabindex="-1" autocomplete="off"></label></div>' +
        '<button class="cta" data-cb-send type="submit">Send this to MAA</button>' +
        /* Sits under the button, not above it. A rider who has decided to send
           does not need to be stopped and made to read a policy — but the form
           asks for a name, an email and a phone number, and it should say
           plainly where they go before they are handed over. */
        '<p class="cb-priv">We use your details to answer this enquiry and ' +
        'nothing else. See our <a href="/pages/privacy-your-data" ' +
        'target="_blank" rel="noopener">privacy policy</a>.</p>' +
        '<p class="gst">Or call us on 07 3350 1354.</p></div>';
      OUT.hidden = true;
      host.hidden = false;
      setText("tot", "—");
      setText("totlbl", (CARD && YEAR) ? who + " · custom build" : "Custom build");
      setDisabled(true);
    }
    /* The enquiry body carries only what Shopify cannot list by itself.

       Name, email, phone, bike and notes all post as contact[...] fields, so
       Shopify prints them as labelled lines — with the email as a mailto link.
       Repeating them in the body, which the first working version did, meant
       every value arrived twice. What is left here is the part that has no
       field equivalent: the routing decision and the manifest version, so a
       quote can be traced back to the exact rules that produced it. */
    function enquiryBody(f, bike) {
      var L = ["Custom build enquiry from the kit builder."];
      if (CARD && YEAR) {
        L.push("");
        L.push("BIKE");
        L.push("  " + bike);
        L.push("");
        L.push("WHAT THE BUILDER RESOLVED");
        L.push("  Card:       " + CARD.label + " (" + CARD.id + ")");
        L.push("  Year:       " + YEAR);
        if (ROW) {
          L.push("  Electrical: " + (ROW.elec || "—"));
          L.push("  Fitment:    " + (ROW.fit || "—"));
          L.push("  Route:      " + (ROW.route_status || "—"));
          L.push("  Kit status: " + (ROW.bom_status || "—"));
          if (ROW.hd_code) L.push("  H-D code:   " + ROW.hd_code);
        }
        if (MAN && MAN.manifest_version) L.push("  Manifest:   " + MAN.manifest_version);
      } else {
        L.push("");
        L.push("The rider could not find their bike in the builder, so nothing was");
        L.push("resolved. Their own description is in the Bike field above.");
      }
      return L.join("\n");
    }

    function onCbSubmit(e) {
      var host = CBHOST();
      function v(k) {
        var n = host && host.querySelector('[data-cb="' + k + '"]');
        return n ? n.value.trim() : "";
      }
      function stop(msg) {
        e.preventDefault();
        var wrap = host && host.querySelector(".cb");
        if (!wrap) return;
        var w = wrap.querySelector(".cb-err");
        if (!w) {
          w = document.createElement("p");
          w.className = "gst cb-err";
          wrap.appendChild(w);
        }
        w.textContent = msg;
      }

      var known = !!(CARD && YEAR);
      var f = { name: v("name"), email: v("email"), phone: v("phone"),
                notes: v("notes"), bike: v("bike") };
      var bike = known ? (YEAR + " " + CARD.label) : f.bike;

      /* Email is required rather than "phone or email" because Shopify's
         contact form will not accept a submission without one. Better to say so
         than to let someone fill the form and have it rejected downstream.

         The form carries novalidate: the browser's own bubble fires before this
         handler and says something blander in a different voice, so validation
         is done here and said once. type="email" still sets the right keyboard
         on a phone. */
      if (!f.name) return stop("We need your name so we know who we're talking to.");
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(f.email)) {
        return stop("We need a working email address — that's how the quote comes back to you.");
      }
      if (!known && !bike) return stop("Tell us what you ride, even roughly. That's the part we can't guess.");
      // Honeypot filled: a bot. Refuse quietly and tell it nothing.
      if (v("hp")) { e.preventDefault(); return; }

      var bodyInput = host.querySelector('[data-cbf="body"]');
      if (bodyInput) bodyInput.value = enquiryBody(f, bike);

      // The page is about to reload, so the bike has to survive the trip if the
      // thank-you is going to name it. Nothing else here is worth keeping.
      try { sessionStorage.setItem("maa_cb_bike", bike); } catch (err) {}

      var btn = host.querySelector("[data-cb-send]");
      if (btn) { btn.disabled = true; btn.textContent = "Sending…"; }
      // and now the browser submits it, exactly as it would any other form.
    }

    function thanksPanel() {
      hideCbHost();
      OUT.innerHTML =
        '<div class="cb"><b>Thanks — that\'s with us.</b><p>We\'ll come back to you' +
        (POSTED_BIKE ? " about your " + POSTED_BIKE : "") +
        '. If you\'d rather talk it through now, call 07 3350 1354.</p></div>';
      setText("tot", "—");
      setText("totlbl", "Enquiry sent");
      setDisabled(true);
    }
    function showThanksIfPosted() {
      if (!/[?&]contact_posted=true/.test(location.search)) return false;
      try {
        POSTED_BIKE = sessionStorage.getItem("maa_cb_bike") || "";
        sessionStorage.removeItem("maa_cb_bike");
      } catch (e) {}
      /* Sticky, not a one-off write. The manifest arrives on its own schedule
         and calls render() when it does, which would otherwise wipe the
         confirmation a moment after the rider read it. The flag clears the
         first time they touch the builder again. */
      POSTED = true;
      thanksPanel();
      // So a refresh does not re-congratulate someone who sent nothing.
      if (window.history && history.replaceState) {
        history.replaceState({}, "", location.pathname +
          location.search.replace(/([?&])contact_posted=true&?/, "$1").replace(/[?&]$/, ""));
      }
      return true;
    }

    function renderOut() {
      // A confirmation the rider has just been shown outranks anything we would
      // otherwise draw here, including a late-arriving manifest.
      if (POSTED) return thanksPanel();
      hideCbHost();
      // A chosen bike with no approved kit is a custom build, not an empty state.
      if (CARD && YEAR && (!ROW || ROW.bom_status !== "approved")) return customBuild(ROW);
      var b = P ? MAAKB.resolve(P, S) : null;
      LAST_BUILD = b;          // the why-sheet reads the line it belongs to
      if (!b) {
        OUT.innerHTML = "";
        setText("tot", "—");
        setText("totlbl", !CARD ? "Choose your Harley"
          : !YEAR ? "Choose your year" : "Choose speaker locations");
        setDisabled(true);
        return;
      }
      var groups = {}, order = [];
      b.lines.forEach(function (l) {
        if (!groups[l.g]) { groups[l.g] = []; order.push(l.g); }
        groups[l.g].push(l);
      });
      var h = "<h2>Your system</h2><div class=\"sys\"><div class=\"sys-hd\">" +
        "<b>" + bikeName(b) + " · " + levelName(b.level) + "</b>" +
        "<small>" + b.speakers + " speakers · " +
        (b.arch === "a2b" ? "Skyline / A2B" : "Analogue") +
        (b.dsp ? " · 8-channel DSP" : "") + "</small></div>";
      order.forEach(function (g) {
        h += '<div class="blk"><b>' + g + "</b>";
        groups[g].forEach(function (l) {
          var pt = P.parts[l.sku];
          // A shared SKU can carry a label naming the variant chosen.
          h += '<div class="li"><span class="nm">' + (l.label || pt.n) +
               (l.qty > 1 ? " ×" + l.qty : "") + '</span>' +
               '<button class="sku" data-why="' + l.sku + '" type="button">' +
               l.sku + "</button></div>";
        });
        h += "</div>";
      });
      var t = b.targets;
      if (t && t.wpc) {
        /* The numbers below are real and worth publishing — they are what an
           installer measures against, and they are a large part of why this
           reads as a configurator rather than a product page. But they are not
           what a buyer needs in order to decide, and having them permanently on
           screen made the panel shout engineering at someone who wanted a
           price.

           So: one plain sentence by default, the full target table one click
           away. <details> rather than JS, so it survives with scripting off and
           costs no state. */
        h += '<div class="blk"><b>MAA setup profile</b>' +
          '<div class="tgt-note">Output limits and crossover settings matched to the ' +
          'selected speakers and amplifier.</div>' +
          /* The wrapper div is a padding hook, nothing more.

             It was added believing it fixed a collapse bug — the test reported
             the rows "visible" while the panel was shut. That was the test
             being wrong, not the markup: Chrome hides closed <details> content
             with `content-visibility`, not `display:none`, so the children keep
             a layout box and a non-null offsetParent while not being rendered.
             Measured properly the panel is 23px closed and 149px open, and was
             correct before the wrapper existed. Probe closed <details> with
             checkVisibility() or the host's own height, never offsetParent. */
          '<details class="tgt-more"><summary>Technical setup details</summary>' +
          '<div class="tgt-body">' +
          '<div class="tgt"><span>Amplifier</span><span>' + t.wpc + "W × " + b.wiring.channels +
          " @ " + b.wiring.minRated + "Ω</span></div>";
        // One target per selected position, at the impedance that position is
        // actually wired to — which is 4Ω for the rear pairs once they share
        // a channel pair, so the Vrms figure changes with the configuration.
        (b.positions || []).forEach(function (k) {
          var tg = t.byPosition[k];
          if (!tg) return;
          var nm = (P.positionMeta && P.positionMeta[k] && P.positionMeta[k].label) || k;
          // Voltage is measured at the amplifier, on the load it actually sees.
          // Where two pairs share a channel pair the speaker impedance and the
          // presented load differ, so say which one the figure refers to.
          var shared = tg.ohm !== b.wiring.presentedLoad[k];
          h += '<div class="tgt"><span>' + nm + ' target</span><span>' + tg.w + "W · " +
            tg.v.toFixed(1) + " Vrms at the amplifier" +
            (shared ? " (2 × " + tg.ohm + "Ω in parallel)" : " @ " + tg.ohm + "Ω") +
            (tg.capped ? " (speaker-limited)" : "") + "</span></div>";
        });
        /* Deliberately not a number, and deliberately not a `.tgt` row.

           The rows above are targets an installer can measure against. The
           filter and gain settings are not: they differ front to rear, and
           publishing them would mean the builder resolving and displaying a
           separate profile per position — a lot of machinery for something the
           workshop sets before dispatch anyway. Nate, 19 Aug 2026: keep the
           actual settings in house.

           So this states that the tuning is matched, without publishing what to.
           A full-width note rather than a label/value pair, because there is no
           value to put in the right column. */
        h += "</div></details>";
        h += "</div>";
      }
      if (b.preorder && b.preorder.length) {
        h += '<div class="note"><b>Available to pre-order:</b> ' +
          b.preorder.map(function (l) {
            return l.sku + (l.qty > 1 ? " ×" + l.qty : "");
          }).join(", ") +
          ". Order now and we'll confirm the expected dispatch date once your " +
          "order is placed.</div>";
      }
      /* Different promise, deliberately. These lines are at zero on a part
         Shopify will NOT sell past zero, so offering a pre-order would promise
         something checkout refuses. And because the stock figure here is baked
         at generation time it may simply be out of date — so this says we will
         check, rather than asserting anything. It does not block: the engine
         reports stock and never enforces it. */
      if (b.confirm && b.confirm.length) {
        h += '<div class="note"><b>We\'ll confirm availability:</b> ' +
          b.confirm.map(function (l) {
            return l.sku + (l.qty > 1 ? " ×" + l.qty : "");
          }).join(", ") +
          ". Our stock figure for these is out of date more often than not — " +
          "we'll check and come back to you before anything is dispatched.</div>";
      }
      if (b.incomplete) h += '<div class="note"><b>' + b.incomplete + "</b></div>";
      // Notes are fitment assumptions still awaiting confirmation. They do not
      // change the BOM, so they are shown alongside it rather than blocking it —
      // blocks have already been folded into `incomplete` above.
      (b.advisories || []).forEach(function (a) {
        if (a.level === "block") return;
        h += '<div class="note">' + a.text + "</div>";
      });
      h += '<div class="totline"><small>System total · inc GST</small><b>' + money(b.total) + "</b></div>" +
        '<button class="cta panel-cta" type="button" data-atc>Add to cart</button></div>' +
        '<span class="vtag">platform ' + b.platform + " · config " + b.configVersion + "</span>";
      OUT.innerHTML = h;

      setText("tot", money(b.total));
      setText("totlbl", b.incomplete ? b.incomplete
        : (bikeName(b) + " · " + levelName(b.level)));
      setDisabled(!!b.incomplete);
    }

    /* Add to cart.

       One POST with every line, because a kit is one decision. /cart/add.js is
       all-or-nothing: if any line is rejected the whole request fails and the
       cart is left untouched, which is the behaviour we want — a half-added
       system priced as a whole one is worse than no cart at all.

       That all-or-nothing behaviour is also why every builder part is set to
       continue selling. Otherwise a single $65 harness going out of stock would
       block every build containing it, and on 18 Aug 2026 that was all 410 of
       them.

       Variant ids come from the platform file, generated from Shopify by
       _gen_parts.py. Nothing is looked up by SKU at runtime. */
    function addToCart() {
      var b = MAAKB.resolve(P, S);
      if (!b || b.incomplete) return;

      var missing = b.lines.filter(function (l) { return !(P.parts[l.sku] || {}).vid; });
      if (missing.length) return cartFailed(missing.map(function (l) { return l.sku; }), null);

      var bundle = bundleId();
      var who = bikeName(b);
      var kit = who + " · " + levelName(b.level);

      var items = b.lines.map(function (l) {
        var pt = P.parts[l.sku];
        var props = {
          /* Visible on the line. Repeated on every row, which is the cost of
             individual lines without a bundles app — but it is also the thing
             that tells a rider at a glance that these parts belong together. */
          "Kit": kit,
          /* Hidden from the customer, kept on the order. An order can be traced
             back to the exact rules that produced it: which build, which
             platform config, which version of the routing table. */
          "_bundle_id": bundle,
          "_build": S.model + "/L" + b.level.id + "/" + (b.positions || []).join("+"),
          "_config": b.configVersion,
          "_manifest": (MAN && MAN.manifest_version) || ""
        };
        if (l.pos && l.pos.length) props["_position"] = l.pos.join(", ");
        return { id: pt.vid, quantity: l.qty, properties: props };
      });

      /* Posted back to front, on purpose.

         A multi-item /cart/add.js comes out of Shopify in reverse: post the
         amplifier first and it lands at the bottom of the cart, under the
         harnesses. Confirmed against the real cart (Nate, 19 Aug 2026) — the
         pre-order amplifier was the last line on the page. So the payload is
         reversed here and the cart reads in BOM order: amplifier, speakers
         front to back, fitment, harnessing.

         This compensates for Shopify's behaviour rather than describing our
         own, which makes it the one line here that could silently invert if
         Shopify ever changes it. _e2e_cart.js asserts the payload order, so
         the check is "the cart looks wrong" -> read this comment. */
      items.reverse();

      var btn = null;
      all("[data-atc]").forEach(function (n) {
        btn = btn || n;
        n.disabled = true;
      });
      all('[data-el="atc"]').forEach(function (n) { n.textContent = "Adding…"; });

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ items: items }),
        credentials: "same-origin"
      }).then(function (r) {
        if (!r.ok) return r.json().catch(function () { return null; })
                    .then(function (e) { cartFailed(null, e || {}); });
        /* The cart asks the rider for their bike so the unit can be programmed
           before it ships. We already know it — better than they do — so the
           kit fills it in rather than making someone retype what they just
           told us. Failure here is not worth blocking on: the kit is already
           in the cart, and the field is still there to be typed into. */
        return setBikeAttribute(bikeSummary(b))
          .catch(function () {})
          .then(function () { window.location.href = "/cart"; });
      }).catch(function () { cartFailed(null, null); });
    }

    /* What goes in the cart's Bike information field. Year and model, what they
       chose in step 2, and the level — the three things needed to confirm
       compatibility and pre-program a head unit. Position labels come from the
       platform file, so a Tour Pack reads "Tour-Pak" here exactly as it does
       everywhere else. */
    function bikeSummary(b) {
      var pos = (b.positions || []).map(function (k) {
        return (P.positionMeta && P.positionMeta[k] && P.positionMeta[k].label) || k;
      });
      return bikeName(b) +
        (pos.length ? " · " + pos.join(" + ") : "") +
        " · " + levelName(b.level) + " (MAA kit builder)";
    }

    /* Cart attributes are cart-wide, not per line. Someone configuring a second
       bike would otherwise overwrite the first, and the difference between
       "two kits for one bike" and "two kits for two bikes" is the whole point
       of the field — so append rather than replace.

       BOUNDED AT 500, and that number is not ours to choose. The cart page
       renders this attribute into `snippets/maa-cart-bike-info.liquid`, a
       design-chat file, as the initial value of a `required` textarea carrying
       `maxlength="500"` and a visible "n/500" counter.

       `maxlength` constrains typing, not a server-rendered value, so an
       over-length attribute does not error — it renders a required field the
       rider CANNOT extend without first deleting text they did not write, under
       a counter reading something like 669/500. Silent, and it lands on the one
       page where a rider is trying to check out.

       So 500 is the interface, not a guess. Shopify itself documents no maximum
       for a cart attribute value; if it ever enforces one, it will be larger
       than this and this cap still holds. **If that textarea's maxlength
       changes, this constant must change with it** — see
       `claude/builder-cart-interface.md`.

       The cap is also editorial. Whoever picks the order reads this to confirm
       fitment and pre-program a head unit. A run-on does not serve that person
       even if Shopify stores it happily.

       Overflow is NEVER silently dropped. Kits for every configured bike are in
       the cart whether or not this field lists them, so a quietly trimmed entry
       would leave the picker confidently reading an incomplete list. Overflow
       becomes a visible count and a phone number instead. */
    var BIKE_KEY  = "Bike information";
    var BIKE_SEP  = " | ";
    var BIKE_MAX_LEN = 500;   // == the textarea maxlength in maa-cart-bike-info.liquid
    var BIKE_MAX  = 6;
    var BIKE_MORE = /^\+(\d+) more bikes? — call /;

    /* Pure, so it can be tested without a cart or a browser. */
    function joinBikeInfo(was, summary) {
      var carried = 0;
      var entries = String(was == null ? "" : was).split(BIKE_SEP)
        .map(function (s) { return s.trim(); })
        .filter(function (s) {
          if (!s) return false;
          /* An existing overflow marker is not an entry — but its COUNT has to
             survive. The bikes it stands for were never stored, so recomputing
             from the visible entries alone would silently undercount on every
             subsequent add. */
          var m = BIKE_MORE.exec(s);
          if (m) { carried += parseInt(m[1], 10) || 0; return false; }
          return true;
        });

      if (summary && entries.indexOf(summary) === -1) entries.push(summary);
      if (!entries.length) return "";

      function marker(n) {
        return "+" + n + " more bike" + (n === 1 ? "" : "s") + " — call 07 3350 1354";
      }

      var kept = [], over = carried;
      for (var i = 0; i < entries.length; i++) {
        if (kept.length >= BIKE_MAX) { over++; continue; }
        if (kept.concat([entries[i]]).join(BIKE_SEP).length > BIKE_MAX_LEN) { over++; continue; }
        kept.push(entries[i]);
      }

      /* One entry longer than the whole cap still has to go somewhere. Keep it
         and let it be long: a field that says nothing is worse than a field
         that says one true thing at length. */
      if (!kept.length) return entries[0];
      if (!over) return kept.join(BIKE_SEP);

      // Make room for the marker itself, counting anything it displaces.
      while (kept.length > 1 &&
             (kept.join(BIKE_SEP) + BIKE_SEP + marker(over)).length > BIKE_MAX_LEN) {
        kept.pop(); over++;
      }
      return kept.join(BIKE_SEP) + BIKE_SEP + marker(over);
    }

    function setBikeAttribute(summary) {
      var KEY = BIKE_KEY;
      return fetch("/cart.js", { credentials: "same-origin",
                                 headers: { "Accept": "application/json" } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) {
          var was = (cart && cart.attributes && cart.attributes[KEY]) || "";
          var value = joinBikeInfo(was, summary);
          var attrs = {};
          attrs[KEY] = value;
          return fetch("/cart/update.js", {
            method: "POST",
            headers: { "Content-Type": "application/json", "Accept": "application/json" },
            body: JSON.stringify({ attributes: attrs }),
            credentials: "same-origin"
          });
        });
    }

    /* A build id that survives into the order. Not security-sensitive — it only
       has to be unlikely to collide with another rider's build in the same
       minute. */
    function bundleId() {
      return "maa-" + Date.now().toString(36) + "-" +
             Math.random().toString(36).slice(2, 8);
    }

    /* Shopify's own message here is written for a developer: it names a variant
       id and says "You can only add N to the cart". A rider needs to know which
       part stopped it and what to do next, so we translate. */
    function cartFailed(skus, err) {
      var name = null;
      if (skus && skus.length) {
        name = skus.join(", ");
      } else if (err) {
        // Shopify returns the offending variant in description/message.
        var text = [err.description, err.message].filter(Boolean).join(" ");
        Object.keys(P.parts).forEach(function (k) {
          if (!name && text.indexOf(String(P.parts[k].vid)) > -1) name = P.parts[k].n;
        });
      }
      all("[data-atc]").forEach(function (n) { n.disabled = false; });
      all('[data-el="atc"]').forEach(function (n) { n.textContent = "Add to cart"; });
      OUT.innerHTML =
        '<div class="cb"><b>We couldn\'t add this system to your cart.</b>' +
        "<p>" + (name
          ? "Something went wrong with <b>" + name + "</b>, and nothing was added — " +
            "your cart is exactly as it was."
          : "Nothing was added, so your cart is exactly as it was.") +
        " Call us on 07 3350 1354 and we'll put the order through for you, or " +
        "try again in a moment.</p></div>";
    }

    document.addEventListener("click", function (e) {
      // Checked before data-close: the footer button carries one or the other,
      // never both, but ordering makes that explicit rather than incidental.
      var wy = e.target.closest("[data-why]");
      if (wy) return whySheet(wy.dataset.why);
      if (e.target.closest("[data-back]")) return modelSheet();
      if (e.target.closest("[data-close]")) return closeSheet();
      var cd = e.target.closest("[data-card]");
      if (cd) return selectCard(cd.dataset.card);
      var yr = e.target.closest("[data-year]");
      if (yr) return selectYear(+yr.dataset.year);
      var gp = e.target.closest("[data-grp]");
      if (gp) { GRP = gp.dataset.grp || null; modelSheet(); return; }
      if (e.target.closest("[data-from-all]")) { FROM = null; modelSheet(); return; }
      /* The escape hatch lives inside the model sheet, so the sheet has to come
         down with it — otherwise the form it sends you to renders underneath a
         panel that is still covering the screen. selectYear() already closes on
         its way out; this path did not. */
      if (e.target.closest("[data-esc]")) { closeSheet(); return customBuild(null); }
      if (e.target.closest("[data-atc]")) return addToCart();
      if (!ROOT.contains(e.target) && !(SHELL && SHELL.contains(e.target))) return;
      var go = e.target.closest("[data-go]");
      if (go) return go.dataset.go === "model" ? modelSheet() : yearSheet();
      var tg = e.target.closest("[data-toggle]");
      if (tg) {
        var n = +tg.dataset.toggle;
        OPEN = (OPEN === n) ? -1 : n;   // -1 = deliberately all closed
        render();
        return;
      }
      var o = e.target.closest("[data-set]");
      if (!o) return;
      var k = o.dataset.set, v = o.dataset.v;
      if (k === "level") v = +v;
      if (!S) return;
      if (k === "positions") {
        // Selection arrives as a joined key; expand it back to the list and drop
        // any lid answer that no longer applies to the new set of positions.
        var opt = posOptions().filter(function (x) { return x.key === v; })[0];
        S.positions = opt ? opt.list : null;
        if (!opt || opt.list.indexOf("Saddlebags") < 0) S.lids = "cut";
        /* A level the new position set cannot drive must not survive the change.
           levelsFor() now also filters on how many positions the rider has taken,
           so such a level's button disappears from the ladder while the answer
           would stay in state — the step header would still name it, options()
           would still render beneath it, and the build would still resolve
           against it, with nothing selected in the ladder to explain why. Drop
           it and make them choose again. Same reasoning as the lids reset above. */
        if (S.level && !MAAKB.levelsFor(P, S).some(function (L) { return L.id === S.level; })) S.level = null;
        OPEN = S.positions ? STEP.level : null;  // answered locations -> open the level step
      } else {
        S[k] = v;
        if (k === "level") OPEN = -1;    // answered the level -> collapse, show the build
      }
      render();
      if (k === "level" && window.innerWidth < 900) {
        setTimeout(function () {
          var target = OPTS && OPTS.children.length ? OPTS : OUT;
          if (target) {
            var top = window.pageYOffset + target.getBoundingClientRect().top - 74;
            window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
          }
        }, 60);
      }
    });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeSheet(); });

    /* LIVE PRICES, installed before anything resolves.

       The host section renders a variantId -> cents map from the
       `maa-builder-parts` collection. It is server-rendered rather than
       fetched, so there is no request to fail and no CDN copy to go stale:
       Shopify invalidates the page cache when a price changes.

       Read it synchronously and install it before the first render. If the
       block is absent or unparseable the engine falls back to the baked
       prices, which is exactly the behaviour that shipped before this - so a
       failure here degrades to the old system rather than to a broken page. */
    try {
      var pnode = ROOT.querySelector("[data-maa-prices]");
      if (pnode) MAAKB.setLivePrices(JSON.parse(pnode.textContent));
    } catch (e) {
      /* Deliberately swallowed, but never silently: the engine reports
         priceSource "baked" on every build from here, which is the signal. */
      if (window.console) console.warn("MAA kit builder: live price map unreadable, falling back to baked prices.", e);
    }

    /* Live stock and inventory policy. Read separately from prices and in its
       own try/catch, so a fault in one cannot take out the other. */
    try {
      var snode = ROOT.querySelector("[data-maa-stock]");
      if (snode) MAAKB.setLiveStock(JSON.parse(snode.textContent));
    } catch (e2) {
      if (window.console) console.warn("MAA kit builder: live stock map unreadable, falling back to baked stock and policy.", e2);
    }

    /* The manifest is fetched once. Until it arrives there is nothing to ask,
       so the first sheet waits rather than showing a platform list that no
       longer exists. */
    var murl = reg.getAttribute("data-manifest");
    if (murl) {
      fetch(murl).then(function (r) { return r.json(); }).then(function (j) {
        MAN = j; FROM = readFrom(); render();
      }).catch(function () {
        setText("totlbl", "Could not load the model list — call 07 3350 1354.");
      });
    }

    var CBFORM = document.getElementById("maa-cb-form");
    if (CBFORM) CBFORM.addEventListener("submit", onCbSubmit);

    /* Reveal the sticky total bar.

       The section renders it with an inline `display:none` so that the
       pre-JavaScript HTML does not contain a "Choose your Harley" label and a
       disabled Add-to-cart button attached to nothing — that markup read as a
       broken store to anything parsing source rather than running scripts.

       Clearing the inline style rather than assigning a display value hands
       layout back to maa-kb.css, which owns what `.bar` actually is.

       This runs SYNCHRONOUSLY in boot, deliberately ahead of the manifest
       fetch. The failure path for that fetch writes its message into
       `totlbl`, which lives inside this bar — revealing the bar only on
       success would make the one message a rider needs to see the one message
       that cannot be displayed. */
    if (BAR) BAR.style.display = "";

    /* The Add-to-cart label is written here, not in Liquid, for the same
       reason: shipping the words in the HTML advertises a checkout button
       that does nothing until this script runs. render() already writes the
       total label on every pass, but nothing wrote the button text, so it
       would otherwise stay blank.

       Guarded on emptiness so this can never overwrite a live state — by the
       time an add is in flight the button reads "Adding…", and a second boot
       (shopify:section:load fires one in the theme editor) must not reset
       that to "Add to cart". */
    all('[data-el="atc"]').forEach(function (n) {
      if (!n.textContent.trim()) n.textContent = "Add to cart";
    });

    render();
    // After render, so the confirmation is not immediately overwritten by it.
    showThanksIfPosted();
  }

  function init() {
    Array.prototype.forEach.call(
      document.querySelectorAll(".maa-kb:not(.maa-kb-barshell):not(.maa-kb-sheet)"), boot);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
  document.addEventListener("shopify:section:load", init);
})();
